import $ from 'jquery';
import { announcements, announcementInit } from './announcements';
import { mobileMenuInit } from './mobileMenu';
import cartCount from './cartCount';
import headroomInit from './headroomInit';

let mobile_menu_open = false;

export default function() {
  cartCount();
  
  $(document).on('shopify:section:load', (e) => {
    if (e.detail.sectionId !== 'INF-Header') { return; }

    // Reinit mobile menu & headroom
    mobileMenuInit();
    headroomInit();

    // If the mobile menu was open previously, reopen it
    if (mobile_menu_open) {
      $('[data-state]').addClass('State--mobile-menu-open');
    }    

    $('[data-announcements-carousel]').each((i, carousel) => {
      const id = $(carousel).parent().attr('id');
      let index = 0;

      // Has this carousel already been initialized? Destroy it if so...
      if (announcements[id] > 0) {
        // Save the current slide's index so we can immediately reinitialize at the same slide later
        index = announcements[id].selectedIndex;
        // Destroy the existing one since it exists
        announcements[id].destroy();
        delete announcements[id]; 
      }
      
      // Reinitialize the carousel with new options
      announcementInit($(carousel), index);
    });
  });

  $(document).on('shopify:section:unload', (e) => {
    if (e.detail.sectionId !== 'INF-Header') { return; }

    mobile_menu_open = false;
    
    if ($('[data-state]').hasClass('State--mobile-menu-open')) {
      mobile_menu_open = true;
    }
  });

  $(document).on('shopify:block:select', (e) => {  
    if (e.detail.sectionId !== 'INF-Header') { return; }

    // Navigate to the correct slide and pause autoplay
    const block_id = e.detail.blockId;
    const index = $(`[data-block-${block_id}]`).eq(0).index();
    
    $('[data-announcements-carousel]').each((i, carousel) => {
      const id = $(carousel).parent().attr('id');
      announcements[id].select(index);
      announcements[id].pausePlayer();
    });    
  });

  $(document).on('shopify:block:deselect', (e) => {
    if (e.detail.sectionId !== 'INF-Header') { return; }

    // Unpause autoplay
    $('[data-announcements-carousel]').each((i, carousel) => {
      const id = $(carousel).attr('id');
      announcements[id].unpausePlayer();
    });
  });
}